import { sendGAEvent } from '../utils';

export enum EBonusesEvents {
  BONUS_RECEIVE_SETTINGS = 'bonus_receive_settings',
}

interface IBonusReceiveSettings {
  status: 'on' | 'off';
  source: string;
}

/**
 * @param data - The data to be sent with the event.
 * @description This function sends a Google Analytics event when user change bonus receive settings.
 * It uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `bonus_receive_settings` and the category is `bonusesEvents`.
 * The data object contains the status, source
 */
export const sendBonusReceiveSettingsEvent = (data: IBonusReceiveSettings) => {
  sendGAEvent(EBonusesEvents.BONUS_RECEIVE_SETTINGS, {
    event_category: 'bonusesEvents',
    ...data,
  });
};
